import script from "./Religion.vue?vue&type=script&setup=true&lang=js"
export * from "./Religion.vue?vue&type=script&setup=true&lang=js"

import "./Religion.vue?vue&type=style&index=0&id=75b09146&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75b09146"]])

export default __exports__